<template>
  <div class="gl-management-wrapper">
    <LazyGLListOrder v-if="isGlNavigationEnabled" />
    <LazyGLListWithNavigation v-else />
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: "GLManagement",
  components: {
    LazyGLListOrder: () => import(/* webpackChunkName: "gl-list-order" */ './GLListOrder.vue'),
    LazyGLListWithNavigation: () => import(/* webpackChunkName: "gl-list-with-navigation" */ './GLListWithNavigation.vue')
  },
  computed: {
    ...mapGetters(['isGlNavigationEnabled'])
  },
};
</script>
